<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    :isUnitButton = 'true'
    :unitText="'Cancel'"
    @cancel="isShow=false"
  >
    <div class="email-dialog">
      <email-tree
        :companies="companies"
        :email="email"
        :isEdit="true"
        :customerId="customerId"
        @changeType="handleChange"
      ></email-tree>
    </div>
  </dialog-component>
</template>

<script>
import emailTree from './email-tree'
export default {
  name: 'editEmailDialog',
  components:{
    emailTree
  },
  props:{
    companies:{
      type:Array,
      default:()=>([])
    },
    email:{
      type:String,
      default:''
    },
    customerId:{
      type:[ Number,String],
      default:''
    }
  },
  data(){
    return{
      isShow:false
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Linked Accounts',
      }
    }
  },
  methods:{
    handleShow(){
      this.isShow = !this.isShow
    },
    handleLink(){
      this.isShow = false
      this.$emit('refresh')
    },
    handleChange(type){
      this.isShow = false
      this.$emit('openDialog',type)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
